<template>
  <el-dialog
    width="600px"
    class="moduleAdd addDialog"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :show-close="false">
    <div slot="title" class="dialogTitle moduleAdd_title">
      <span>{{optionTitle}}xxx</span>
    </div>
    <div class="moduleAdd_con addDialog_con">
      <div class="moduleAdd_form">
        <el-form
          ref="form"
          label-position="right"
          label-width="110px"
          :model="form"
          :rules="formRules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="xxx编码：" prop="code" :rules="formRules.required">
                <el-input v-model.trim="form.code" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="xxx名称：" prop="name" :rules="formRules.required">
                <el-input v-model.trim="form.name" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="submitBtn">
            <el-button type="primary" @click="onSubmit" :loading="confirmBtnDis">提交</el-button>
            <el-button @click="onCancle" :disabled="confirmBtnDis">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { isNumber } from '@/utils/validate';
  // 接口
  import { test, testByGet } from '@/api/common';
  
  // 自定义验证规则
  const validators = {
    isNumber: function (rule, value, callback) {
      if (value && !isNumber(value)) {
        callback(new Error('请输入数字'));
      } else {
        callback();
      }
    }
  };
  
  // 初始化表单
  function getInitForm () {
    return {
      code: '',
      name: ''
    };
  }
  
  export default {
    name: 'moduleAdd',
    inject: ['myMessage'],
    props: {
      fatherData: Object
    },
    data () {
      return {
        visible: false,
        confirmBtnDis: false,
        id: '',
        optionType: 'add', // 默认是新增
        optionTitle: '新增', // 默认是新增
        detailsData: {},
        form: getInitForm(),
        formRules: {
          required: [
            { required: true, message: '不能为空' }
          ],
          isNumber: [
            { trigger: ['change', 'blur'], validator: validators.isNumber }
          ]
        }
      };
    },
    watch: {
      visible (val, oldVal) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
        
        if (val) {
          if (this.fatherData.optionType === 'edit') {
            this.id = this.fatherData.id;
            this.optionType = 'edit';
            this.optionTitle = '修改';
            this.requestDetails();
          }
        } else {
        
        }
      }
    },
    methods: {
      requestDetails () {
        testByGet(this.id)
          .then(res => {
            this.handleInitData(res.data);
          })
          .catch(() => {
            this.myMessage.megError('获取详情信息失败');
          });
      },
      
      requestUpdateData () {
        this.confirmBtnDis = true;
        
        // 请求接口 默认是新增的
        let requestUrl = test;
        if (this.optionType === 'edit') {
          // 修改的接口
          requestUrl = test;
        }
        
        requestUrl(this.handleFormData())
          .then(resData => {
            this.myMessage.megSuc(this.optionTitle + '成功');
            this.$emit('onRefreshList', this.optionType);
            this.onCancle();
          })
          .catch(() => {
            this.myMessage.megError(this.optionTitle + '失败');
          })
          .finally(() => {
            this.confirmBtnDis = false;
          });
      },
      
      // 处理请求数据
      handleFormData () {
        const requestData = { ...this.form };
        if (this.optionType === 'edit') {
          requestData.id = this.id;
        }
        
        return requestData;
      },
      
      // 处理修改时的初始值
      handleInitData (data) {
        this.detailsData = { ...data };
        Object.keys(this.form).forEach(key => {
          this.form[key] = data[key];
        });
      },
      
      onSubmit () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.requestUpdateData();
          }
        });
      },
      
      onCancle () {
        this.visible = false;
        this.confirmBtnDis = false;
        this.id = '';
        this.optionType = 'add';
        this.optionTitle = '新增';
        this.detailsData = {};
        setTimeout(() => {
          this.form = getInitForm();
        }, 500);
      }
    }
  }
  ;
</script>

<style lang="scss">
  .moduleAdd {
  }
</style>
